export const StyleModifiers = ['container-style', 'secondary', 'destructive', 'destructive-secondary', 'info', 'info-secondary', 'tertiary'];
